import React from "react";

export const Success: React.FC = () => {
    return <p>success</p>
}